import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Parametro } from 'src/app/model/Parametro';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ParametroService {
  private urlApi = environment.rootUrlApi + 'apoio/parametro';

  constructor(private http: HttpClient) { }

  public ping(): Observable<any> {
    return this.http.get<any>(this.urlApi + '/ping');
  }

  public listaParametro(): Observable<Parametro[]> {
    return this.http.get<Parametro[]>(this.urlApi + '/lista');
  }

  public add(dados: Parametro): Observable<any> {
    return this.http.post<Parametro>(this.urlApi + '/add', dados);
  }

  public update(dados: Parametro): Observable<any> {
    return this.http.post<Parametro>(this.urlApi + '/update', dados);
  }

  public delete(id: number): Observable<any> {
    return this.http.delete<any>(this.urlApi + '/delete/' + id);
  }

  public get(id: number): Observable<Parametro> {
    return this.http.get<Parametro>(this.urlApi + '/get/' + id);
  }

  public getParam(): Observable<Parametro> {
    return this.http.get<Parametro>(this.urlApi + '/getParam');
  }
}
